
import React, {Component} from 'react';
import {connect} from 'react-redux'
import ReportGeneralTable from './ReportGeneralTable'
import ReportStore from '../../stores/ReportStore'
import FontAwesome from 'react-fontawesome';
import {Checkbox} from 'react-icheck'
import {Popover,OverlayTrigger,Modal} from 'react-bootstrap';
import { momentHelper } from './helpers'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import IframeModal from '../../component/element/IframeModal'
import CreditNoteDoc from '../doc/CreditNoteDoc'
import JSWorkDocViewModal from 'view/workdoc/JSWorkdocViewModal';
import TaxinvoiceModal from '../doc/TaxinvoiceModal'
import ReportTaxinvoicePage from './ReportTaxinvoicePage'
// import { setTimeout } from 'timers';

const cHeaderTitles = [
  {title:'วันที่ออก',width:'100px'},
  {title:'ใบลดหนี้',width:'120px'},  
  {title:'ใบกำกับภาษี',width:'120px'},
  {title:'ใบงานเลขที่',width:'220px'},
  {title:'ทะเบียนรถ',width:'150px'},
  {title:'ยี่ห้อ',width:'150px'},
  {title:'รุ่น',width:'150px'},
  {title:'กม.',width:'80px'},
  {title:'ชื่อลูกค้า',width:'200px'},
  {title:'มูลค่า(บาท)',width:'100px'},  
]

// const cHeaderTitlesCompany = [
//   {title:'วันที่ออก',width:'100px'},
//   {title:'ออกโดย',width:'100px'},
//   {title:'ใบกำกับภาษี',width:'120px'},
//   {title:'ใบงานเลขที่',width:'220px'},
//   {title:'ทะเบียนรถ',width:'150px'},
//   {title:'ยี่ห้อ',width:'150px'},
//   {title:'รุ่น',width:'150px'},
//   {title:'กม.',width:'80px'},
//   {title:'ชื่อลูกค้า',width:'200px'},
//   {title:'มูลค่า(บาท)',width:'100px'},   
//   {title:'วันรับเงิน',width:'100px'},       
// ]

const cHeaderTitlesAll = [
  {title:'',width:'50px',checkAll:true},
  {title:'วันที่ออก',width:'100px'},
  {title:'ใบลดหนี้',width:'120px'}, 
  {title:'ใบกำกับภาษี',width:'120px'} , 
  {title:'ใบงานเลขที่',width:'220px'},
  {title:'ทะเบียนรถ',width:'150px'},
  {title:'ยี่ห้อ',width:'150px'},
  {title:'รุ่น',width:'150px'},
  {title:'กม.',width:'80px'},
  {title:'ชื่อลูกค้า',width:'200px'},
  {title:'มูลค่า(บาท)',width:'100px'},        
]
// const cHeaderTitlesAllCompany = [
//   {title:'',width:'50px',checkAll:true},
//   {title:'วันที่ออก',width:'100px'},
//   {title:'ออกโดย',width:'100px'},
//   {title:'ใบกำกับภาษี',width:'120px'},
//   {title:'ใบงานเลขที่',width:'220px'},
//   {title:'ทะเบียนรถ',width:'150px'},
//   {title:'ยี่ห้อ',width:'150px'},
//   {title:'รุ่น',width:'150px'},
//   {title:'กม.',width:'80px'},
//   {title:'ชื่อลูกค้า',width:'200px'},
//   {title:'มูลค่า(บาท)',width:'100px'},   
//   {title:'วันรับเงิน',width:'100px'},       
// ]
// const viewModeList = ['all','unpaid','paid','cancel']
class ReportCreditNotePage extends Component {

  
  constructor(...args){
    super(...args)
    const month = momentHelper.getMonth()
    const year = momentHelper.getYear()
    // const day = momentHelper.getDay()
    const searchBy = 'invoice_no'
    const query = ''
    this.state = {
      _that:undefined,
      doc_no:'',
      taxinvoice_no:'',
      doc_title:'ใบลดหนี้',
      showTable:true,
      data:[],
      companylist:[],
      activeKey:1,
      month: month,
      year: year,
      day : '00',
      searchBy: searchBy,
      query: query,
      activePage: 0,
      itemPerPage:13,
      check:[],
      headerTitles:cHeaderTitlesAll,
      // headerTitlesAll:cHeaderTitlesAll,
      isCheckAll:false,
      showSelectMenu:false,
      showTivTable:false,
      showTivItem:false,
      pdf_template:{PrintTaxInvoiceCoverNote:'PrintKKCTaxInvoiceCoverNote',PrintTaxInvoiceCoverNoteInsurer:'PrintKKCTaxInvoiceCoverNoteInsurer'}
    }
    this.loadedData = false
  }

  showTable(){
    let {_that} = this.state
    this.setState({showTable:true,doc_no:''})
    if (_that!==undefined) {
      setTimeout(()=>{
        _that.refreshTable() 
      },100)
    }  
    if(this.props.onTableShow!==undefined){
      this.props.onTableShow()
    }
  }



  loadDataRange(start,end,searchBy,query,activePage,itemPerPage,callback){
    ReportStore.loadCreditNoteListRange('all',start,end,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
      this.processData(result)
      callback(result)
    })
  }

  loadData(year,month,day,searchBy,query,activePage,itemPerPage,callback){
    ReportStore.loadCreditNoteList('all',year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
      this.processData(result)
      callback(result)
    })

    // if (activeKey===1 ) {
    //   this.loadedData = true       
    //   ReportStore.loadTaxinvoiceList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
    //     result.data = result.data.map((item,index)=>{
    //       item = Object.assign({check:false},item)
    //       return item
    //     })
    //     if (result.companylist.length>1) {
    //       headerTitlesAll = cHeaderTitlesAllCompany
    //     }        
    //     this.setState({data:result.data,companylist:result.companylist,headerTitlesAll:headerTitlesAll,isCheckAll:false,check:new Array(result.data.length).fill(false)})
    //     callback(result)
    //   })            
    // } else if (activeKey===2 ) { 
    //   ReportStore.loadUnpaidList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
    //     if (result.companylist.length>1) {
    //       headerTitles = cHeaderTitlesCompany
    //     }
        
    //     this.setState({data:result.data,companylist:result.companylist,headerTitles:headerTitles,isCheckAll:false})
    //     callback(result)
    //   })
    // } else if (activeKey===3) { 
    //   ReportStore.loadPaidList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
    //     this.setState({data:result.data,isCheckAll:false})
    //     callback(result)
    //   })
    // } else if (activeKey===4) { 
    //   ReportStore.loadCancelList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
    //     this.setState({data:result.data,isCheckAll:false})
    //     callback(result)
    //   })
    // }
  }

  processData(result){
    let {headerTitles,activeKey,pdf_template} = this.state
    if (activeKey===1) {
      headerTitles = cHeaderTitlesAll
      result.data = result.data.map((item,index)=>{
        item = Object.assign({check:false},item)
        return item
      })
      // if (check.length===0)
      //   this.setState({check:new Array(result.data.length).fill(false)})
      // else
      //   this.setState({check:check}) 
      this.setState({isCheckAll:false,showSelectMenu:false,check:new Array(result.data.length).fill(false)})
    } else {
      headerTitles = cHeaderTitles
    }
    pdf_template = Object.assign(pdf_template,result.pdf_template)
    this.setState({pdf_template:pdf_template,companylist:result.companylist,headerTitles:headerTitles,data:result.data}) 
  }

  // renderStatus(status,row){
  //   status = status*1
  //   let result  = (<span></span>)
  //   if(status===1){
  //     result =  (<span className='label label-success'>ชำระเงินแล้ว</span>)
  //   }else    if(status===2){
  //     result =  (<span className='label label-primary'>ขายเครดิต</span>)
  //   }else{
  //     result = (<span></span>)
  //   }
  //   if(row.recordid!==undefined && row.recordid*1>0){
  //     result = (<div>{result} {this.renderStockStatus(row.recordid)}</div>)
  //   }
  //   return result
  // }

  renderStatus(status,row){
    let result = (<span></span>)

    if (row.work_status==='0') {
      result = (<span className="label label-default" data-value="0"><FontAwesome name='clock-o'/> เริ่มต้น</span>)
    }else if (row.work_status==='1') {
      result = (<span className="label label-warning" data-value="1"><FontAwesome name='wrench'/> อยู่ระหว่างซ่อม</span>)
    } else if (row.work_status==='2') {
      result = (<span className="label label-primary" data-value="2"><FontAwesome name='hourglass-start'/> รอส่งมอบรถ</span>)
    } else if (row.work_status==='3') {
      result = (<span className="label label-success" data-value="3"><FontAwesome name='thumbs-o-up'/> ปิดจบงาน</span>)
    } else if (row.work_status==='5') {
      result = (<span className="label label-purple" data-value="5"><FontAwesome name='bitcoin'/> ตั้งเบิก</span>)
    } else{
      result = (<span></span>)
    }

    if(row.doc_status!==undefined && row.doc_status*1===2){
      result = (<div>{result}<span  className="label label-success"><FontAwesome name='money'/> ชำระเงินแล้ว</span></div>)
    }
    if(row.doc_cancel!==undefined && row.doc_cancel*1===1){
      result = (<div>{result}<span  className="label label-danger"><FontAwesome name='trash'/> ยกเลิก</span></div>)
    }

    if(row.doc_cancel_remark!==undefined && row.doc_cancel_remark!==''){
      result = (<div>{result}<span  className="label label-danger"><FontAwesome name='trash'/> {row.doc_cancel_remark}</span></div>)
    }

    return result
  }

  renderWorkNo(data,row){
    if (data!=="" && data!==null) {
      let title = "ใบงานซ่อม "+data
      let popoverHoverFocus = (
        <Popover id="popover-trigger-hover-focus" title={title}>
          <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
        </Popover>
      )

      return (
        <span>
          {data} <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}><FontAwesome onClick={this.onIconClick.bind(this,data)} className="text-blue" name='file-text-o'/></OverlayTrigger>
        </span>
      )
    }else{
      return (<span>{data}</span>)  
    } 
  }

  renderTaxinvoiceNo(data,row){
    if (data!=="" && data!==null) {
      let title = "ใบกำกับภาษี "+data
      let popoverHoverFocus = (
        <Popover id="popover-trigger-hover-focus" title={title}>
          <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบกำกับภาษี</strong>
        </Popover>
      )

      return (
        <span>
          {data} <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}><FontAwesome onClick={this.onIconTivClick.bind(this,row.taxinvoice_no)} className="text-green" name='file-text-o'/></OverlayTrigger>
        </span>
      )
    }else{
      return (<span>{data}</span>)  
    } 
  }

  // renderStockStatus(status){ 
  //   status = status*1
  //   if(status>0){
  //     return (<span className='label label-default'>ตัดสต๊อกแล้ว</span>)
  //   }else{
  //     return (<span></span>)
  //   }
  // }

  onIconClick(workNo,e) {
    // if (process.env.NODE_ENV === "development") {
    //   alert('show_work_doc:'+workNo)
    // }else{
    //   window.show_work_doc(workNo)
    // }
    this.refs.jsWork.loadData(workNo)
  }

  onIconTivClick(tivNo,e) {
    if (process.env.NODE_ENV === "development") {
      alert('show_taxinvoice_doc:'+tivNo)
    }else{
      window.show_taxinvoice_doc(tivNo)
    }
  }


  // onCheckChange(rowIndex){
  //   let {showSelectMenu,data,check,isCheckAll} = this.state

  //   let ind=0;
  //   let checkItems = data.reduce((rresult,item)=>{
  //     if(check[ind]){
  //       rresult.push(item)
  //     }      
  //     ind++;
  //     return rresult
  //   },[])
    
  //   if(!check[rowIndex] && !this.validateSameCustomer(data[rowIndex],checkItems)){
  //     this.setState({showSelectEror:true})
  //     return
  //   }
  //   check[rowIndex] = !check[rowIndex]

  //   showSelectMenu = false
  //   check.map((item,index)=>{
  //     if(item){
  //       showSelectMenu = true
  //     }
  //     return item
  //   })
    
  //   isCheckAll = this.checkAll(check)
  //   this.setState({check:check,showSelectMenu:showSelectMenu,isCheckAll:isCheckAll})
  // }

  onCheckChange(rowIndex){
    let {showSelectMenu,check,isCheckAll} = this.state

    // let ind=0;
    // let checkItems = data.reduce((rresult,item)=>{
    //   if(check[ind]){
    //     rresult.push(item)
    //   }      
    //   ind++;
    //   return rresult
    // },[])
    
    // if(!check[rowIndex] && !this.validateSameCustomer(data[rowIndex],checkItems)){
    //   this.setState({showSelectEror:true})
    //   return
    // }
    check[rowIndex] = !check[rowIndex]

    showSelectMenu = false
    // check.map((item,index)=>{
    //   if(item){
    //     showSelectMenu = true
    //   }
    //   return item
    // })
    let key = check.findIndex(x=>x!==false)
    if (key!==-1)
      showSelectMenu = true
    
    isCheckAll = this.checkAll(check)
    this.setState({check:check,showSelectMenu:showSelectMenu,isCheckAll:isCheckAll})
  }

  // checkAll(check) {
  //   let isCheckAll = true
  //   check.forEach((item,index)=>{
  //     if (!item)
  //       isCheckAll = false
  //   })
  //   return isCheckAll
  // }

  checkAll(check) {
    let {data} = this.state
    let isCheckAll = true
    check.forEach((item,index)=>{
      if (!item&&data[index].work_status!=='3')
        isCheckAll = false
    })
    return isCheckAll
  }

  validateSameCustomer(newItem,checkItems){
    let valid = true
    checkItems.map((item,index)=>{      
      if(item.customer_name!==newItem.customer_name){
        valid = false
      }
      return item
    })

    return valid
  }

  // renderRowData(){ //data
  //   //let renderColumn = (this.props.onRenderColumn!==undefined)?this.props.onRenderColumn:this.onRenderColumn.bind(this)
  //   let {data,check,activeKey,companylist,headerTitles} = this.state
  //   let firstRowAt = -1;
  //   data = data.map((newRow, rid) => {
  //     //let newRow = JSON.parse(JSON.stringify(row))   
      
  //     if(rid>0 && data[rid-1].doc_no===data[rid].doc_no){        
  //       if(firstRowAt<0)
  //         firstRowAt = rid-1
  //       data[firstRowAt]['rowSpan'] = data[firstRowAt]['rowSpan']+1
  //       data[rid]['rowSpan'] = 0
  //     }else{
  //       firstRowAt = -1
  //       newRow['rowSpan'] = 1
  //     }      
  //     return newRow
  //   })
    
  //   if(data.length===0){
  //     return (<tr><td colSpan={headerTitles.length}>ไม่พบข้อมูล</td></tr>)
  //   } else {
  //     return data.map((item,index)=>(
  //       (
  //         <tr key={index}>
  //           {this.state.activeKey==1 ? (<td className='text-center'><Checkbox onChange={this.onCheckChange.bind(this,index)} checked={check[index]} checkboxClass="icheckbox_square-blue" increaseArea="20%" label="" /></td>) : ('') }
  //           {item.rowSpan>0?(<td rowSpan={item.rowSpan}  onClick={this.onRowSelect.bind(this,item)}>{item.doc_date}</td>):('')}
  //           {companylist.length>1?(<td onClick={this.onRowSelect.bind(this,item)}>{item.issued_doc_by}</td>):('')}
  //           {item.rowSpan>0?(<td rowSpan={item.rowSpan}  onClick={this.onRowSelect.bind(this,item)}>{item.bill_no}</td>):('')}
  //           <td>{this.renderWorkNo(item.work_no,item)}</td>
  //           <td onClick={this.onRowSelect.bind(this,item)}>{item.car_registration_no}</td>
  //           <td onClick={this.onRowSelect.bind(this,item)}>{item.brand}</td>
  //           <td onClick={this.onRowSelect.bind(this,item)}>{item.model}</td>
  //           <td onClick={this.onRowSelect.bind(this,item)}>{item.mileage}</td>
  //           {item.rowSpan>0?(<td rowSpan={item.rowSpan}  onClick={this.onRowSelect.bind(this,item)}>{item.customer_name}</td>):('')}
  //           {item.rowSpan>0?(<td rowSpan={item.rowSpan} className='text-right'  onClick={this.onRowSelect.bind(this,item)}>{item.amount}</td>):('')}
  //           <td onClick={this.onRowSelect.bind(this,item)}>{item.payment_date}</td>
            
  //         </tr>
  //       )
  //     ))
  //   }
  // }

  validBeforePrint(_data) {
    let customer_name = []
    _data.forEach((item,index)=>{
      if (item) {
        if (customer_name.indexOf(item.customer_name)===-1)
          customer_name.push(item.customer_name)
      }
    })
    
    return customer_name.length>1?false:true
  }

  // onTypePrintSelect(number) {
  //   if (number===2) {
  //     this.onPrintClick(number)
  //   } else {
  //     let {check} = this.state
  //     let isValideCustomer = this.validBeforePrint(check)
  //     if (isValideCustomer) {
  //       this.onPrintClick(number)
  //     } else {
  //       this.setState({showSelectEror:true})
  //     }
  //   }  
  // }

  // onCreditNotePrintSelect(number) {
  //   let {check,data} = this.state
  //   let count_true = 0
  //   check.forEach((item,index)=>{
  //     if (item===true)
  //       count_true++
  //   })
  //   if (count_true>1) {
  //     this.setState({showSelect1Eror:true})
  //     return false
  //   }
  //   if (number===0) {
  //     this.setState({doc_title:'ใบลดหนี้'})
  //   } else if (number===1) {
  //     this.setState({doc_title:'ใบเพิ่มหนี้'})
  //   }
  //   let select = check.indexOf(true)
  //   if (select!==-1)
  //     this.setState({showTaxList:true,taxinvoice_no:data[select].taxinvoice_no})
  // }
  

  onTaxInvoiceSelect(docNo){
    

    this.setState({showTivItem:true,showTivTable:false,taxinvoice_no:docNo})
  }

  onTaxinvoiceSelect(datas) {
    if (datas.itemlist.length>0) {
      let {check,data} = this.state
      this.setState({showTable:false,showTivItem:false})
      let select = check.indexOf(true)
      let doc_no = ''
      if (select!==-1) {
        doc_no = data[select].doc_no
        datas.doc = Object.assign(datas.doc, {doc_no:doc_no})
      }
      this.refs.cnDoc.getWrappedInstance().setDataFromTaxinvoice(datas)
      if (this.props.onDocShow!==undefined)
        this.props.onDocShow(doc_no)  
    }    
  }

  onPrintClick(number) {
    let {check,data} = this.state
    // let _item = {}
    let doc_nos = []

    data.forEach(function(item,index) {
      if (check[index]) {
        // _item = item
        doc_nos.push(item.doc_no)
      }
    })

    let doc_no = doc_nos.join()
    let file = 'PrintShippingLabel&idlist='+doc_no+'&doc=creditnote'
    let url = ''
    if (process.env.NODE_ENV === "development") {
      if (number===2)
        url = './?startPage='+file
      else
        url  = './?startPage='+file+'&tivlist='+doc_no
    } else{
      if (number===2)
        url = './pdf/v2/?startPage='+file
      else
        url = './pdf/v2/?startPage='+file+'&tivlist='+doc_no
    }
    this.refs.iframe.loadUrl(url)
  }
  
  onRenderColumn(data,col,row,rowIndex){
      let {check} = this.state
      // let index = (companylist.length>1)?1:0
      if(col===0||col==='checkbox'){
        return (<Checkbox    
          onChange={this.onCheckChange.bind(this,rowIndex)}      
          checked={check[rowIndex]!==false?true:false}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
          disabled={row.work_status==='3'?true:false}
        />)
      } else if (col==='bill_taxinvoice_no') {
        return this.renderTaxinvoiceNo(data,row)       
      } else if (col==='work_no') {
        return this.renderWorkNo(data,row)     
      } else{ 
        return (<span>{data}</span>)
      }
  }

  onTabsSelect(e) {
    let {headerTitles} = this.state
    if (e===1) {
      headerTitles = cHeaderTitlesAll
    }
    this.setState({activeKey:e,headerTitles:headerTitles})
    // let {year,month,day,searchBy,query,activePage,itemPerPage,headerTitles} = this.state
    // if (e===1) {
    //   ReportStore.loadTaxinvoiceList(year,month,day,searchBy,query,activePage,itemPerPage,(result)=>{
    //     this.setState({data:result.data,activeKey:e,isCheckAll:false})
    //   })
    // } else if (e===2) { 
    //   ReportStore.loadUnpaidList(year,month,day,searchBy,query,activePage,itemPerPage,(result)=>{
    //     if (result.companylist.length>1) {
    //       headerTitles = cHeaderTitlesCompany
    //     }
    //     this.setState({data:result.data,activeKey:e,headerTitles:headerTitles,isCheckAll:false})
    //   })
    // } else if (e===3) { 
      
    //   ReportStore.loadPaidList(year,month,day,searchBy,query,activePage,itemPerPage,(result)=>{
    //     if (result.companylist.length>1) {
    //       headerTitles = cHeaderTitlesCompany
    //     }
    //     this.setState({data:result.data,activeKey:e,headerTitles:headerTitles,isCheckAll:false})
    //   })
    // } else if (e===4) { 
    //   ReportStore.loadCancelList(year,month,day,searchBy,query,activePage,itemPerPage,(result)=>{
    //     if (result.companylist.length>1) {
    //       headerTitles = cHeaderTitlesCompany
    //     }
    //     this.setState({data:result.data,activeKey:e,headerTitles:headerTitles,isCheckAll:false})
    //   })
    // }
  }

  // onCheckAll() {
  //   let {data,isCheckAll,check} = this.state
  //   if (data.length==0)
  //     return false

  //   if (!isCheckAll) {
  //     let isValideCustomer = data.find((item,index)=>{
  //       return this.validateSameCustomer(item,data)==true
  //     })
      
  //     if (!isValideCustomer) {
  //       this.setState({showSelectEror:true})
  //     } else {
  //       let newCheck = check.map((item,index)=>{
  //         if (data[index].work_status=='3')  
  //           item = true // false
  //         else
  //           item = true
          
  //         return item
  //       })

  //       if (newCheck.indexOf(true)==-1)
  //         this.setState({isCheckAll:false,check:newCheck,showSelectMenu:false})
  //       else
  //         this.setState({isCheckAll:true,check:newCheck,showSelectMenu:true})  
  //     }   
  //   } else {
  //     let newCheck = check.map((item,index)=>{
  //       item = false
  //       return item
  //     })
  //     this.setState({isCheckAll:false,check:newCheck,showSelectMenu:false})
  //   }    
  // }

  onCheckAll() {
    let {data,isCheckAll,check} = this.state
    if (data.length===0)
      return false

    if (!isCheckAll) {
      let newCheck = check.map((item,index)=>{
        if (data[index].work_status==='3')
          return false
        else
          return true // data[index]   
      })
      
      this.setState({isCheckAll:true,check:newCheck,showSelectMenu:true})  
    } else {
      let newCheck = check.map((item,index)=>{
        item = false
        return item
      })
      this.setState({isCheckAll:false,check:newCheck,showSelectMenu:false})
    }    
  }

  onRenderCheckAll() {
    return(
      <th key='th-all' className={'text-center'} style={{width:'50px',maxWidth:'50px'}}>
        <Checkbox
          onChange={this.onCheckAll.bind(this)}
          checked={this.state.isCheckAll}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
        >
        </Checkbox>
      </th>
    )
  }

  onDocNew(){
    this.setState({showTivTable:true,taxinvoice_no:''})
  }

  onDocNew2(){
    this.setState({showTable:false})
    this.refs.cnDoc.getWrappedInstance().loadNewDoc((result)=>{
      if (this.props.onDocShow!==undefined)
        this.props.onDocShow(result)
      
    })    
  }

  onRowSelect(item){    
    this.setState({showTable:false})
    this.refs.cnDoc.getWrappedInstance().loadData(item.doc_no)
    if (this.props.onDocShow!==undefined)
      this.props.onDocShow(item.doc_no)
  }

  onDocClose(){
    this.showTable()
  }

  onRef(that) {
    this.setState({_that:that})
  }

  render(){
    let {showTable,showSelectEror,headerTitles,showSelectMenu,showTivTable} = this.state
    
    const searchOptions = [
      {
        label: 'ใบลดหนี้',
        value: 'doc_no'
      },
      {
        label: 'ใบกำกับภาษี',
        value: 'taxinvoice_no'
      },
      {
        label: 'ใบงานเลขที่',
        value: 'work_no'
      },
      {
        label: 'ทะเบียนรถ',
        value: 'car_registration_no'
      },
      {
        label: 'ลูกค้า/เจ้าของรถ',
        value: 'customer_name'
      },
      {
        label: 'บริษัทประกัน',
        value: 'insurance_name'
      }
    ]

    return (
        <div>
          <div style={{display:showTable?'block':'none'}}>
                  <ReportGeneralTable 
                    ref='cdTable' 
                    title='ใบลดหนี้' 
                    newTitle='เพิ่มรายการ'
                    showNewButton={false}
                    showPrintButton={true}
                    showSelectMenu={showSelectMenu}
                    show={true}
                    loadOnShow={false}
                    headerTitles={headerTitles}
                    // excludeColumn={['doc_no','status_html','doc_status','issued_doc_by','work_status','doc_cancel','doc_cancel_remark','taxinvoice_no']}
                    bodyColumn={['checkbox','doc_date','doc_no','bill_taxinvoice_no','work_no','car_registration_no','brand','model','mileage','customer_name','amount']}
                    excludeClickColumn={['work_no','bill_taxinvoice_no']}
                    searchOptions={searchOptions}          
                    searchBy={'doc_no'}
                    loadData={this.loadData.bind(this)}    
                    loadDataRange={this.loadDataRange.bind(this)}
                    onRenderCheckAll={this.onRenderCheckAll.bind(this)}                
                    onRenderColumn={this.onRenderColumn.bind(this)}
                    onRowSelect={this.onRowSelect.bind(this)}
                    onPrintClick={this.onPrintClick.bind(this)}
                    onDocNew={this.onDocNew.bind(this)}
                    // onTypePrintSelect={this.onTypePrintSelect.bind(this)}
                    // onCreditNotePrintSelect={this.onCreditNotePrintSelect.bind(this)}
                    printTitle={'พิมพ์ใบจ่าหน้าซอง'}
                    selectMenuTitle={'สร้างใบปะหน้า'}
                    btnTitlePrint={'พิมพ์ตาราง'}
                    docType={'creditnote'}
                    viewMode={'all'}
                    minWidth={1300}
                    isMobile={this.props.isMobile}
                    mobileFieldMap={{title:'customer_name',amount:'amount',sub_title:'doc_no',date:'doc_date',status:'work_status',sub_status:''}}
                    renderWorkStatus={this.renderStatus.bind(this)} 
                    onRef={this.onRef.bind(this)}
                  />
            </div>
            <div style={{display:(!showTable?'':'none')}}>              
              <CreditNoteDoc                 
                ref='cnDoc' 
                title={this.state.doc_title}
                docType={'creditnote'}
                docSName={'cn'}
                docName={'creditnote_doc'}
                onClose={this.onDocClose.bind(this)}
              />                            
            </div>
            {/* <ConfirmPopup show={showSelect1Eror} title='เกิดช้อผิดพลาด'
              confirmTitle='ทำการเลือกใหม่' cancelTitle='ยกเลิก' message='สามารถเลือกได้ 1 รายการเท่านั้น โปรดลองใหม่'
              onConfirm={() => { this.setState({ showSelect1Eror: false }) }}
              onHide={() => { this.setState({ showSelect1Eror: false }) }}
            /> */}
            <ConfirmPopup show={showSelectEror} title='เกิดช้อผิดพลาด'
              confirmTitle='ทำการเลือกใหม่' cancelTitle='ยกเลิก' message='กรุณาเลือกชื่อลูกค้าหรือประกันเดียวกัน โปรดลองใหม่'
              onConfirm={() => { this.setState({ showSelectEror: false }) }}
              onHide={() => { this.setState({ showSelectEror: false }) }}
            />
           {showTivTable && (<Modal show={showTivTable} onHide={()=>{this.setState({showTivTable:false})}} dialogClassName="midwidth-dialog">
              <ReportTaxinvoicePage onDocShow={this.onTaxInvoiceSelect.bind(this)}/>
            </Modal>)}            
            <TaxinvoiceModal
              show={this.state.showTivItem}
              tivNo={this.state.taxinvoice_no}
              onHide={()=>{this.setState({showTivItem:false})}}
              onItemsSelect={this.onTaxinvoiceSelect.bind(this)}
            /> 
            <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
            <JSWorkDocViewModal ref="jsWork" title={'แสดงผลใบงาน '} modal={true} fullScreen={true}/>
        </div>  
    )
  }
}


export default ReportCreditNotePage = connect(
  (state) => ({messages: state.message.view.report.ReportCreditNotePage}),null,null,{withRef:true}
)(ReportCreditNotePage);






// WEBPACK FOOTER //
// ./src/view/report/ReportCreditNotePage.js